import { DICT } from '@/shared/config/dict';
import { AppLocale } from '@/shared/lib/types';

export const MAX_FILE_SIZE_BYTES = 256 * 1024 * 1024;

export const getMaxFileSizeMessage = (locale: AppLocale): string => DICT.INVALIDATED_FILE_SIZE[locale];
